import { styled } from "@mui/material";

const PageWrapper = styled('div')(() => ({
  zIndex: 1,
  width: '100%',
  backgroundColor: 'transparent',
}));

export default PageWrapper;